import React, { useState } from "react";
import { Checkbox, Col, Input, Row, Select, Tag } from "antd";
import AnalyzeIcon from "../../assets/images/analyzeIcon.png";
import AnalyticsIcon from "../../assets/images/analyticsIcon.png";
import Mangnifer from "../../assets/images/Magnifier.png";
import { useSelector } from "react-redux";
import moment from "moment";

const ExecutuedTable = () => {
  const { data } = useSelector((state) => state.orders);
  const [searchTerm, setSearchTerm] = useState("");

  const tagStyle = {
    backgroundColor: "#9BE9311A",
    color: "#9BE931",
    fontWeight: "bold",
  };

  return (
    <div className="orders_container">
      <div className="orders_header">
        <div className="holdings">
          <h2>Executed Orders({data[0]?.length})</h2>
        </div>

        <div className="detailed">
          <div className="searchitem">
            <div className="magnifier">
              {" "}
              <span>
                <img src={Mangnifer} alt="mangnifier" />
              </span>
            </div>
            <div>
              <input
                type="text"
                className="searchBox"
                placeholder="search"
                onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
              />
            </div>
          </div>
          <div className="detailedIcons">
            <div>
              <div>
                <span>
                  <img src={AnalyticsIcon} alt="analyticsIcon" />
                </span>{" "}
                <p id="analytics"> Contact note</p>
              </div>
            </div>
            <div>
              <div>
                <span>
                  <img src={AnalyticsIcon} alt="analyticsIcon" />
                </span>{" "}
                <p id="analytics">View History</p>
              </div>
            </div>
            <div>
              <div>
                <span>
                  <img src={AnalyticsIcon} alt="analyticsIcon" />
                </span>{" "}
                <p id="download">Download</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/**Table */}
      <table>
        <thead>
          <tr>
            <th>Time</th>
            <th>Type</th>
            <th>Instrument</th>
            <th>Product</th>
            <th>Qty.</th>
            <th>Avg.Price</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {data[0]?.length > 0 &&
            data[0]
              ?.filter((o) => {
                return searchTerm == ""
                  ? o
                  : o?.instrument?.toLowerCase().includes(searchTerm);
              })
              ?.map((orders, index) => {
                return (
                  <tr key={index}>
                    <td className="time">
                      {moment(orders?.orderAt).format("hh:mm:ss")}
                    </td>
                    <td className="qty">
                      <Tag color="#9BE931">{orders?.transactionType}</Tag>
                    </td>
                    <td className="instrument">
                      {orders?.instrument}
                      {/* <span>{orders?.tradingSymbol}</span>
                    <span className="nse">{orders?.exchange}</span> */}
                    </td>
                    <td className="product">{orders?.product}</td>
                    <td className="qty">{orders?.quantity}</td>

                    <td className="avg">3,333.78</td>
                    <td>
                      <Tag style={tagStyle}>COMPLETE</Tag>
                    </td>
                  </tr>
                );
              })}
        </tbody>
      </table>
    </div>
  );
};

export default ExecutuedTable;
